import CodeMirror from 'codemirror';
import { createSpanReplacementNode } from '../markers/utils';
import { hasTokenIncludes } from '../utils/codemirror';
import Selector from '../../ast/declarations/Selector';
import { IDeclarationOninit } from '../../editor/index.d';


/**
 * SELECTOR 函数替换
 * 如有必要，可以在 Marker 上设置点击事件唤起选择器
 */
export function replaceDeclarationSelector(
  editor: CodeMirror.Editor,
  tokens: CodeMirror.Token[],
  idx: number,
  oninit?: IDeclarationOninit) {
  const token = tokens[idx];
  if (hasTokenIncludes(token, ['declaration', 'Selector'])) {
    const line = token.state.line;

    const startPos = { line, ch: token.start };
    const endPos = { line, ch: token.end };

    const { description } = Selector.match(token.string)!;

    const replacedWith = createSpanReplacementNode(description, 'cm-selector');

    if (oninit) {
      (replacedWith as any).removeMarkerListener = oninit({ target: replacedWith, editor, token, position: { start: startPos, end: endPos } });
    }

    editor.getDoc().markText(startPos, endPos, {
      replacedWith
    });
    return 1;
  }


  return 0;
}
